import { useRecoilValue } from "recoil";
import WxContentsDispatcher from "./WxContentsDispatcher";
import { selectedCameraGroupSelector } from "../../../store/LiveCameraState";
import useEffectSkipFirst from "../../../hooks/useEffectSkipFirst";
import { useExecutePreMount } from "../../../hooks/useExecutePreMount";

const LiveCameraDispatcher = (props) => {
  const filterCameraGroup = useRecoilValue(selectedCameraGroupSelector);

  useExecutePreMount(() => {
    if (filterCameraGroup !== undefined) {
      props.contents.setFilterCameraGroup(filterCameraGroup);
    }
  });

  useEffectSkipFirst(() => {
    props.contents.setFilterCameraGroup(filterCameraGroup);
  }, filterCameraGroup);

  return <WxContentsDispatcher {...props}/>
};

export default LiveCameraDispatcher;
